import { Injectable } from '@angular/core';
import { CalculationBet } from '../types/bet.type';
import { BetService } from './bet.service';

@Injectable({
  providedIn: 'root'
})
export class ExposureHelperService {

  constructor(private betService: BetService) { }

  /**
   * Calculate total exposure for all bet types (odds, double chance, asian handicap, goal lines, line)
   */
  calculateTotalExposureForBets(bets: CalculationBet[]): number {
    if (bets.length === 0) return 0;

    // Separate bets by type
    const oddsBets = bets.filter((bet) => !this.betService.isDoubleChanceBet(bet) && !this.betService.isAsianHandicapBet(bet) && !this.betService.isGoalLineBet(bet) && !this.betService.isLineBet(bet));
    const doubleChanceBets = bets.filter((bet) => this.betService.isDoubleChanceBet(bet));
    const asianHandicapBets = bets.filter((bet) => this.betService.isAsianHandicapBet(bet));
    const goalLineBets = bets.filter((bet) => this.betService.isGoalLineBet(bet));
    const lineBets = bets.filter((bet) => this.betService.isLineBet(bet));

    // Get unique IDs from the bets
    const oddsMarketsMarketGroupIds = Array.from(new Set(oddsBets.map((bet) => bet.marketGroupId)));
    const asianHandicapMarketsMarketGroupIds = Array.from(new Set(asianHandicapBets.map((bet) => bet.marketGroupId)));
    const goalLineMarketsMarketGroupIds = Array.from(new Set(goalLineBets.map((bet) => bet.marketGroupId)));
    const doubleChanceMarketsMarketGroupIds = Array.from(new Set(doubleChanceBets.map((bet) => bet.marketGroupId)));
    const lineMarketsUniqueIds = Array.from(new Set(lineBets.map((bet) => `${bet.marketId}-${bet.selectionId}`)));

    // Calculate exposures for each group
    const oddsExposuresStepOne: { [key: string]: number } = {};
    const asianHandicapExposuresStepOne: { [key: string]: number } = {};
    const goalLineExposuresStepOne: { [key: string]: number } = {};
    const doubleChanceExposuresStepOne: { [key: string]: number } = {};
    const lineExposuresStepOne: { [key: string]: number } = {};

    // For each unique IDs, calculate and store the exposure result
    oddsMarketsMarketGroupIds.forEach((marketGroupId) => (oddsExposuresStepOne[marketGroupId] = this.betService.calculateMarketBasedExposure(oddsBets, marketGroupId)));
    asianHandicapMarketsMarketGroupIds.forEach(
      (marketGroupId) => (asianHandicapExposuresStepOne[marketGroupId] = this.betService.calculateAsianHandicapBasedExposure(asianHandicapBets, marketGroupId)),
    );
    goalLineMarketsMarketGroupIds.forEach(
      (marketGroupId) => (goalLineExposuresStepOne[marketGroupId] = this.betService.calculateGoalLineBasedExposure(goalLineBets, marketGroupId)),
    );
    doubleChanceMarketsMarketGroupIds.forEach(
      (marketGroupId) => (doubleChanceExposuresStepOne[marketGroupId] = this.betService.calculateDoubleChanceBasedExposure(doubleChanceBets)),
    );
    lineMarketsUniqueIds.forEach((uniqueId) => (lineExposuresStepOne[uniqueId] = this.betService.calculateRunnerBasedExposure(lineBets, uniqueId)));

    // Sum all the exposures got from the step above (This will be the total exposure)
    const asianHandicapTotalExposure = Object.values(asianHandicapExposuresStepOne).reduce((prev, curr) => prev + curr, 0);
    const goalLineTotalExposure = Object.values(goalLineExposuresStepOne).reduce((prev, curr) => prev + curr, 0);
    const doubleChanceTotalExposure = Object.values(doubleChanceExposuresStepOne).reduce((prev, curr) => prev + curr, 0);
    const lineTotalExposure = Object.values(lineExposuresStepOne).reduce((prev, curr) => prev + curr, 0);

    return  asianHandicapTotalExposure + goalLineTotalExposure + doubleChanceTotalExposure + lineTotalExposure;
  }
}
